import { useQuery } from '@tanstack/react-query';
import { fetchWarehouseMenu } from '@shared/api/menu';
import { useAuth } from '@features/auth/hooks/useAuth';

export const warehouseMenuKey = (cacheUserID: number) => ['menu', cacheUserID, 'warehouse'] as const;

export function useWarehouseMenu() {
  const { user } = useAuth();
  // Client cache partition only; it is never sent as menu authorization.
  const cacheUserID = user?.id ?? 0;
  return useQuery({
    queryKey: warehouseMenuKey(cacheUserID),
    queryFn: fetchWarehouseMenu,
    enabled: cacheUserID > 0,
    staleTime: 60_000,
    refetchInterval: 120_000,
  });
}
